import React from 'react';
import { Badge, BottomNavigation, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import cx from 'classnames';
import { Detector } from 'react-detect-offline';
import { Routes } from '€lib/routing';
import { Hidden } from '../Hidden';
import TopBarNavIcon from '€components/TopBarNavIcon';
import MessageIcon from '€icons/Message';
import BellIcon from '€icons/Bell';
import TopBarAvatar from '€components/TopBarAvatar';
import HomeIcon from '€icons/Home';
import { user } from '€slices/user';
import { TopAppBarHeight } from '€lib/layout';

type Props = {
    fromTopNav?: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            alignItems: 'center',
            height: TopAppBarHeight,
            justifyContent: 'space-between',
            '& .MuiIconButton-sizeSmall': {
                padding: 0,
            },
        },
        nav: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 99,
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
        },
        mobileOffline: {
            marginBottom: '1.75rem',
        },
    }),
);

const TopLevelNavigation: React.FC<Props> = ({ fromTopNav = false }) => {
    const $user = useSelector(user);
    const match = useRouteMatch();
    const classes = useStyles();

    if (!$user) {
        return null;
    }

    return (
        <Detector
            render={({ online }) => (
                <BottomNavigation
                    className={cx(classes.root, {
                        [classes.nav]: !fromTopNav,
                        [classes.mobileOffline]: !fromTopNav && !online,
                    })}
                >
                    <Hidden smUp>
                        <TopBarNavIcon
                            icon={<HomeIcon />}
                            link={Routes.Dashboard}
                            label="Home"
                            // active={false}
                            active={match.path === Routes.Dashboard}
                        />
                    </Hidden>
                    <TopBarNavIcon
                        icon={<BellIcon />}
                        link={Routes.Dashboard}
                        label="Alerts"
                        active={false}
                        // active={match.path === Routes.Dashboard}
                    />
                    <TopBarNavIcon
                        icon={
                            <Badge color="error" variant="dot">
                                <MessageIcon />
                            </Badge>
                        }
                        label="Messages"
                        // link={Routes.ChatInbox}
                        // active={match.path === Routes.ChatInbox}
                    />
                    <TopBarAvatar />
                </BottomNavigation>
            )}
        />
    );
};

export default TopLevelNavigation;
